import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Dialog: Neue Einflussgröße (Name abfragen).
 *
 * Technischer Extract aus App.jsx (Plan A): UI/Keys 1:1, Validierung/State bleibt in App.jsx.
 */
function EinflussNameDialog({
  open,
  value,
  onChange,
  error,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div
      className="dialog-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="dialog-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>➕ {t('config.einflussdb.editor_add_einfluss')}</h3>
        </div>
        <div className="dialog-content">
          <label style={{ display: 'block', marginBottom: '8px' }}>
            {t('config.einflussdb.prompt_new_name')}
          </label>
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="form-input"
            autoFocus
          />
          {error && (
            <p style={{ color: '#b91c1c', marginTop: '8px', fontSize: '0.9rem' }}>
              {error}
            </p>
          )}
        </div>
        <div className="dialog-actions">
          <button className="btn btn-secondary" onClick={onCancel} type="button">
            {t('dialog.cancel')}
          </button>
          <button className="btn btn-primary" onClick={onConfirm} type="button">
            {t('dialog.ok')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EinflussNameDialog;

